import { render, staticRenderFns } from "./PriceQuotationDetailsData.vue?vue&type=template&id=637a328b&"
import script from "./PriceQuotationDetailsData.vue?vue&type=script&lang=js&"
export * from "./PriceQuotationDetailsData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports